export class ResetPasswords {
    static readonly type = '[User] ResetPasswords';

    constructor(public payload: string[]) {}
}
